import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import './plugins/element.js'
import '@/assets/css/global.scss'

Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.$regConfig = window.regConfig

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
